import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_sip-schedule-admin/artifacts/vd09zrou_Logo%20-%20Final.png";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const LoginPage = () => {
  const handleGoogleLogin = () => {
    // Use window.location.origin to dynamically get the current domain
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-sip-cyan/5 to-sip-purple/5 flex items-center justify-center px-4" data-testid="login-page">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-sip-purple rounded-full opacity-10 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-sip-cyan rounded-full opacity-10 blur-3xl" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative z-10 w-full max-w-md"
      >
        <div className="card-graffiti text-center">
          <img 
            src={LOGO_URL} 
            alt="Sip Fantasia" 
            className="h-24 w-auto mx-auto mb-6"
          />
          
          <h1 className="font-script text-3xl text-sip-purple mb-2">
            Admin Login
          </h1>
          <p className="text-gray-600 mb-8">
            Sign in to manage Sip Fantasia content
          </p>

          <button
            onClick={handleGoogleLogin}
            className="w-full bg-white border-2 border-gray-200 rounded-xl p-4 flex items-center justify-center gap-3 hover:bg-gray-50 hover:border-sip-purple transition-all"
            data-testid="google-login-btn"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24">
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            <span className="font-medium text-lg text-gray-700">
              Sign in with Google
            </span>
          </button>

          <p className="text-sm text-gray-500 mt-6">
            Only authorized administrators can access this area.
          </p>

          <Link 
            to="/" 
            className="inline-block mt-6 text-sip-purple hover:underline"
            data-testid="back-to-home"
          >
            ← Back to website
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default LoginPage;
